import React from "react";
import Button from "./Button";
import { useTranslations } from "next-intl";

export const FormError = ({ children }: { children: React.ReactNode }) =>
  children ? (
    <div aria-invalid="true" className="form-field-error-wrapper mb-1">
      <label>{children}</label>
    </div>
  ) : null;

const FormErrors = ({
  errors,
  className,
}: {
  errors: Record<string, any>;
  className?: string;
}) => {
  const t = useTranslations();
  const renderErrors = (errorObj: Record<string, any>): React.ReactNode => {
    return Object.entries(errorObj).flatMap(([key, value]) => {
      if (
        value?.message ||
        value?.serverError ||
        (!value?.message && !value?.serverError && key !== "ref")
      ) {
        return (
          <FormError key={key}>
            {key === "root" ? (
              <p> {value.serverError?.message} </p>
            ) : (
              <Button
                appearance="link"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  try {
                    (value.ref as any)?.focus?.();
                  } catch (e) {
                    console.error(e);
                  }
                }}
              >
                {t(key)}: {value?.message || t(value?.type)}
              </Button>
            )}
          </FormError>
        );
      }

      // If the current value is an object, recursively render its errors
      if (typeof value === "object" && key !== "ref") {
        return renderErrors(value);
      }

      return null;
    });
  };

  if (!errors || Object.keys(errors).length === 0) return null;

  return <div className={`${className} mt-4 pt-2`}>{renderErrors(errors)}</div>;
};

export default FormErrors;
